import { render, staticRenderFns } from "./NoDataAvailable.vue?vue&type=template&id=5479e285&scoped=true"
import script from "./NoDataAvailable.vue?vue&type=script&lang=js"
export * from "./NoDataAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5479e285",
  null
  
)

export default component.exports